import React, { Component } from "react";
import { Form, Input, Table, Modal, Radio } from "antd";
import moment from "moment";
import Cookies from "js-cookie";

import Api from "../../ServiceApi";
import ChangePath from "../../../services/ServiceApi";

class EmployeeShift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],
      visible: false,
      title: "Employee Shift",
      columns: [
        {
          title: "ID",
          render: (item) =>
            !item.employee_shift_id ? "-" : item.employee_shift_id,
          align: "center",
          key: "employee_shift_id",
          sorter: (a, b) => a.employee_shift_id - b.employee_shift_id,
        },
        {
          title: "Name",
          render: (item) =>
            !item.employee_shift_name ? "-" : item.employee_shift_name,
          align: "center",
          key: "employee_shift_name",
          sorter: (a, b) =>
            a.employee_shift_name.length - b.employee_shift_name.length,
        },
        {
          title: "Start",
          // render: (item) =>
          //   !item.employee_shift_start ? "-" : item.employee_shift_start,
          align: "center",
          key: "employee_shift_start",
          render: (item) => <div>{moment(item).format("HH:mm")}</div>,
          sorter: (a, b) => {
            return (
              moment(a.employee_shift_start).unix() -
              moment(b.employee_shift_start).unix()
            );
          },
        },
        {
          title: "End",
          // render: (item) =>
          //   !item.employee_shift_end ? "-" : item.employee_shift_end,
          align: "center",
          key: "employee_shift_end",
          render: (item) => <div>{moment(item).format("HH:mm")}</div>,
          sorter: (a, b) => {
            return (
              moment(a.employee_shift_end).unix() -
              moment(b.employee_shift_end).unix()
            );
          },
        },
        {
          title: "Remark",
          render: (item) =>
            !item.employee_shift_remark ? "-" : item.employee_shift_remark,
          align: "center",
          key: "employee_shift_remark",
        },
        {
          title: "Create By",
          render: (item) => (!item.create_by ? "-" : item.create_by),
          align: "center",
          key: "create_by",
        },
        {
          title: "Status",
          dataIndex: "is_active",
          key: "is_active",
          render: (item) => (
            <div>
              {item === 0 ? (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span>InActive
                </span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
        },
        {
          title: "Action",
          dataIndex: "price",
          key: "price",
          render: (item) => (
            <div>
              <a href="/MaxiOperation/full_detail_job">
                <img src={Api.absoluteUrl("/icon/view.svg")} alt="view-ic" />
              </a>
              <a href="/MaxiOperation/edit_job">
                <img src={Api.absoluteUrl("/icon/edit.svg")} alt="edit-ic" />
              </a>
            </div>
          ),
        },
      ],
    };
  }

  async componentDidMount() {
    //const result = await Api.get("get_employee_shift",  "");
    const result = await Api.post("get_employee_shift", {
      employee_shift_id: null,
      company_id: Cookies.get("companyid"),
    });

    if (result.data.result.code.toUpperCase() === "P") {
      this.setState({
        //data: result.data.data.employee_shift_dto_list,
        data: result.data.data,
        loading: false,
      });
      console.log(this.state.data);
    } else {
    }
  }

  handleSubmit(values) {
    console.log("Success:", values);
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  onModal(visible) {
    this.setState({ visible: visible });
  }

  renderAddEmployee() {
    const { visible, value } = this.state;
    return (
      <Modal
        title={<span className="font-mont-b fs-16 c-blue">ADD EMPLOYEE</span>}
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal"
      >
        <div className="d-flex align-items-center">
          <div className="mr-4">
            <span className="font-thai-r fs-18">Status</span>
          </div>
          <Radio.Group onChange={this.onChange} value={value}>
            <Radio value={1}>
              <span className="font-thai-r fs-18">Active</span>
            </Radio>
            <Radio value={2}>
              <span className="font-thai-r fs-18">Inactive</span>
            </Radio>
          </Radio.Group>
        </div>

        <Form
          onFinish={(values) => this.handleSubmit(values)}
          layout="vertical"
        >
          <div className="row">
            <div className="col-9">
              <div className="row">
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Employee ID"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Employee Name"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Employee Nick name"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Head Employee"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Skill"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter your full name"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Department"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter your full name"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Division"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Enter your full name"
                    />
                  </Form.Item>
                </div>
                <div className="col">
                  <Form.Item
                    name="fullname"
                    label="Tel"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <Form.Item
                    name="fullname"
                    label="E-mail"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="font-mont-r fs-12"
                      type="text"
                      size="large"
                      placeholder="Please Input"
                    />
                  </Form.Item>
                </div>
              </div>

              <Form.Item
                name="Address"
                label={<div className="font-mont-m fs-12">Reason</div>}
                rules={[
                  {
                    required: true,
                    message: "โปรดเขียนรายละเอียด",
                  },
                ]}
              >
                <Input.TextArea rows={4} placeholder="Please Input" />
              </Form.Item>
            </div>
            <div className="col-3">
              <Form.Item
                name="fullname"
                label="Profile Picture"
                rules={[{ required: true, message: "Full name is required" }]}
              ></Form.Item>
            </div>
          </div>

          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.onModal(false)}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">Add</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  render() {
    const { title, data, columns } = this.state;
    return (
      <div>
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>
        <div className="d-flex justify-content-between my-3">
          <Input.Search
            placeholder="Search"
            onSearch={(value) => console.log(value)}
            style={{ width: 200 }}
          />
          <button
            className="btn btn-warning"
            onClick={() => this.onModal(true)}
          >
            <img
              src={ChangePath.absoluteUrl("/img/modal_approve.svg")}
              className="mr-2"
              alt="mod-app-ic"
            />
            Add {title}
          </button>
        </div>
        <Table rowKey="employee_shift_id" columns={columns} dataSource={data} />
        {this.renderAddEmployee()}
      </div>
    );
  }
}

export default EmployeeShift;
